<template>
  <div class="myStatistics-index">
    <headCard :type='type' />
    <overview :state="state" />
    <backlog :state="state" :restChart="restChart" />
    <totalOrder :state="state" :type='type' />
    <discount :sevenDataArr='sevenDataArr' />
  </div>
</template>

<script>
import headCard from "./components/headCard";
import overview from "./components/overview";
import backlog from "./components/backlog";
import totalOrder from "./components/totalOrder";
import discount from "./components/discount";
import {
  getPcCount,
  countCustomerAnalysis,
  sevenData,
} from "@/api/myStatistics";
import {getDataTimeSec} from "@/utils/index"
import i18nMixin from '@/mixins/i18nMixin';
export default {
  name: "myStatistics",
  mixins: [i18nMixin],
  components: {
    headCard,
    overview,
    backlog,
    totalOrder,
    discount,
  },
  props: {
    type: {
      type: Number,
      default: 1,
    },
  },
  created() {
    this.getPcCount();
    this.countCustomerAnalysis();
    this.sevenData();
  },
  data() {
    return {
      state: {},
      restChart: [],
      sevenDataArr:[]
    };
  },
  watch: {
    // 监听语言变化
    currentLanguage() {
      this.updateOrderTypes();
    }
  },
  methods: {
    async getPcCount() {
      const reslut = await getPcCount({ type: this.type });
      console.log(reslut)
      if(reslut.data.newCustomerList){
        reslut.data.newCustomerList.map(val =>{
          val.createTime = getDataTimeSec(val.createTime)
        }) 
        
      }
      this.state = reslut.data;
    },
    async countCustomerAnalysis() {
      const result = await countCustomerAnalysis({ type: this.type });
      
      this.restChart = result.data;
    },
    async sevenData() {
      const result = await sevenData({ type: this.type });
      const { orderList, dealList } = result.data;
      if(orderList.length > 0){
        orderList.map(item =>{
          if(item.amount){
            item.amount = (item.amount/100).toFixed(2)
          }
        })
      }
      if(dealList.length > 0){
        dealList.map(item =>{
          if(item.amount){
            item.amount = (item.amount/100).toFixed(2)
          }
        })
      }
      
      orderList.map((item) => {
        item.city = this.$t('dashboard', 'mallOrder');
      });
      dealList.map((item) => {
        item.city = this.$t('dashboard', 'personalOrder');
      });
      this.sevenDataArr = orderList.concat(dealList);
    },
    updateOrderTypes() {
      // 更新订单类型文本
      if (this.sevenDataArr && this.sevenDataArr.length > 0) {
        this.sevenDataArr.forEach(item => {
          if (item.amount) {
            // 根据数据特征判断是商城订单还是个人订单
            // 这里需要根据实际业务逻辑来判断
            if (item.assembleId) {
              item.city = this.$t('dashboard', 'mallOrder');
            } else {
              item.city = this.$t('dashboard', 'personalOrder');
            }
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>